import * as React from "react";
import {useSelector} from "react-redux";
import {getBannersRight} from "../../../store/selectors/banners/banners.selector";
import BannerFrame from "../BannerFrame";

const BannersHomeRight: React.FC = () => {
  const banners = useSelector(getBannersRight)
  return (
    <div className="ml-2 bckgr-black">
      {
        banners.map(banner => <BannerFrame key={banner.bannerId} banner={banner}/>)
      }
    </div>
  )

}

export default BannersHomeRight;
